import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { BodyShort01 } from 'components/styles';
import { CostRateDrawerExtras } from '..';

const HeaderWrapper = styled.div`
  height: var(--layout-05);
`;

const ResourceName = styled.div`
  ${BodyShort01};
  color: var(--gray-50);
`;

type Props = Pick<CostRateDrawerExtras, 'resourceName'>;

export const CostRateDrawerHeader: FC<Props> = ({ resourceName }) => {
  return (
    <HeaderWrapper>
      <FormattedMessage id="settings.cost_rates.title" />
      <ResourceName>{resourceName}</ResourceName>
    </HeaderWrapper>
  );
};
